import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { apiFetch } from './client';
import type { AuditEntry, AppendAuditRequest } from './types';

const KEY = ['audit'] as const;

export function useAuditEntries() {
  return useQuery({
    queryKey: KEY,
    queryFn: () => apiFetch<AuditEntry[]>('/audit'),
    staleTime: 15_000,
    refetchInterval: 30_000,
  });
}

export function useAppendAudit() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: AppendAuditRequest) =>
      apiFetch<AuditEntry>('/audit', { method: 'POST', body: JSON.stringify(body) }),
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY }),
  });
}
